import styled from 'styled-components'

import { COLOURS, BREAKPOINTS } from 'resources'
import { backgroundImageSmall } from 'resources/images'

export const BalanceTitle = styled.div`
  font-weight: bold;
  font-size: 24px;
`

export const Text = styled.span`
  color: ${COLOURS.black};
  font-style: normal;
  text-align: left;
  padding: 5px 0;
`

export const BalanceGraphicContainer = styled.div`
  background-image: url(${backgroundImageSmall});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: relative;
  width: 80vw;
  height: 80vw;
  max-width: 400px;
  max-height: 400px;
`

export const BalanceGraphicBackgroundContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 20%;

  @media (min-width: ${BREAKPOINTS.lg}) {
    padding: 90px;
  }
`

export const RedemptionRequirementsContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  height: 50px;
  border-radius: 25px;
  border: none;
  padding: 10px 30px;
  background-color: ${COLOURS.hollywoodCerise};
  color: ${COLOURS.white};
  transition: background-color 0.2s, color 0.2s;
  font-weight: bold;
  width: 100%;

  :disabled {
    cursor: not-allowed;
  }

  :hover:not(:disabled) {
    background-color: ${COLOURS.hollywoodCeriseDarken};
  }
`

export const RedemptionSelectionContainer = styled(RedemptionRequirementsContainer)``

export const RedemptionSelectionTitle = styled.div`
  font-family: 'Druk', sans-serif;
  font-size: 36px;
  line-height: 1;
  margin-top: 30px;
`

export const RedemptionRequirementsTitle = styled.div`
  padding: 1rem 0;
  font-size: 18px;
  font-weight: bold;
`

export const RedemptionRequirementContainer = styled.div`
  padding: 1rem 0;
  display: flex;
  align-items: center;
`

export const RedemptionRequirementText = styled.span`
  font-size: 16px;
  display: flex;
  text-align: left;
`

export const Icon = styled.img`
  align-self: flex-start;
  width: 15px;
  height: 15px;
  margin-right: 10px;
  margin-top: 6px;
`

export const ExternalProviderLogo = styled.img`
  width: 100%;
  height: 100%;
  max-width: 130px;
`

export const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;
  max-width: 450px;
  width: 100%;
  margin: auto;
`
